<template>
    <div>
        <template v-if="loading">
            LOADING!
        </template>
        <template v-else>
            <my-carousel :per-page="1" :per-page-custom="[[768, 3]]" :navigation-enabled="true" v-cloak>
                <carousel-slide class="px-8 text-center" :ref="`slide-${index}`" v-for="(entry, index) in entries" :key="entry.id">
                    <a :href="entry.url">
                    <img :src="entry.image.transforms.squareMd" :srcset="getSrcSet(entry)" class="w-3/6 md:w-full mx-auto" :alt="entry.image.title">
                    </a>
                    <h3 class="pt-4 md:pt-6 font-title text-2xl lg:text-2xl xl:text-3xl lh-4 xl:lh-8">
                    <a :href="entry.url">
                        {{ entry.title }}
                    </a>
                    </h3>
                    <div class="pt-4 uppercase text-grey-500">
                        <span v-if="entry.descendants">
                            {{ entry.descendants }} PIECES
                        </span>
                    </div>
                </carousel-slide>
            </my-carousel>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                page: 0,
                entries: [],
            }
        },
        methods: {
            fetch() {
                axios.get('/api/portfolio.json').then(response => {
                    this.entries = response.data.data;
                    this.loading = false;
                })
            },
            getSrcSet(entry) {
                const transforms = entry.image.transforms;
                return `${transforms.squareXl} 3000w, ${transforms.squareLg} 2000w, ${transforms.squareMd} 1200w, ${transforms.squareSm} 800w,`;
            }
        },
        mounted() {
            this.fetch();
        }
    }
</script>

<style scoped>
    .VueCarousel-slide-center {
        opacity: 1
    }
</style>